import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import Currencies from '../../library/dynamics/currencies';

function CurrencySelect({ value = null, onChange, ...otherProps }) {
    return (
        <Radio.Group buttonStyle="solid"
            onChange={onChange}
            value={value}
            {...otherProps}
        >
            {Currencies.map((currency) => (
                <Radio.Button key={currency.id} value={currency.id} label={currency.name}>
                    {currency.code} ({currency.symbol})
                </Radio.Button>
            ))}
        </Radio.Group>
    );
}

CurrencySelect.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func
}

export default CurrencySelect;